(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => initializeProductGallery());

  // Re-initialize when theme editor updates the section
  document.addEventListener('shopify:section:load', () => {
    // Use setTimeout to ensure DOM is fully updated
    setTimeout(() => initializeProductGallery(), 100);
  });

  function initializeProductGallery() {
    if (window.productGalleryCleanup) {
      window.productGalleryCleanup();
      window.productGalleryCleanup = null;
    }

    const mainSlider = document.querySelector('#main-slider');
    const thumbnailSlider = document.querySelector('#thumbnail-slider');

    if (!mainSlider) return;

    // Clean up existing instances to prevent memory leaks
    if (window.splideInstances) {
      const existingMain = window.splideInstances.get('main-slider');
      const existingThumbnails = window.splideInstances.get('thumbnail-slider');

      if (existingMain && !existingMain.state.is.destroyed) {
        existingMain.destroy();
      }
      if (existingThumbnails && !existingThumbnails.state.is.destroyed) {
        existingThumbnails.destroy();
      }
    }

    // Count total slides
    const totalSlides = mainSlider.querySelectorAll('.splide__slide').length;

    // Initialize main slider
    const main = new Splide('#main-slider', {
      type: 'slide',
      pagination: false,
      arrows: totalSlides > 1,
      rewind: true,
      lazyLoad: 'nearby',
      keyboard: 'global',
      drag: totalSlides > 1,
      focus: 'center',
      trimSpace: false,
    });

    // Initialize thumbnail slider if exists
    let thumbnails = null;
    let thumbnailResizeObserver = null;
    let thumbnailResizeListener = null;
    if (thumbnailSlider) {
      thumbnails = new Splide('#thumbnail-slider', {
        direction: 'ttb',
        height: '40rem',
        perPage: 5,
        gap: 5,
        rewind: true,
        pagination: false,
        isNavigation: true,
        arrows: false,
        waitForTransition: true,
        lazyLoad: 'nearby',
        keyboard: false,
        drag: true,
        focus: 'center',
        breakpoints: {
          990: {
            direction: 'ltr',
            height: 'auto',
            perPage: 5,
            gap: 8,
            arrows: false,
            pagination: false,
            focus: 0,
            trimSpace: true,
          },
        },
      });

      main.sync(thumbnails);

      const thumbnailCount = thumbnailSlider.querySelectorAll('.splide__slide').length;
      const desktopQuery = window.matchMedia('(min-width: 1024px)');
      const desktopGap = 5;
      const mobilePerPage = 5;
      const mobileGap = 8;
      let lastMode = '';
      let lastHeight = 0;
      let lastPerPage = 0;
      let thumbnailLayoutFrame = null;

      const applyThumbnailLayout = () => {
        if (!thumbnails || thumbnails.state.is.destroyed) return;

        const isDesktop = desktopQuery.matches;
        if (!isDesktop) {
          if (lastMode === 'mobile') return;

          thumbnails.options = {
            direction: 'ltr',
            height: 'auto',
            perPage: mobilePerPage,
            gap: mobileGap,
            drag: thumbnailCount > 1,
            focus: 0,
            trimSpace: true,
            wheel: false,
            releaseWheel: false,
          };
          thumbnails.refresh();

          lastMode = 'mobile';
          lastHeight = 0;
          lastPerPage = mobilePerPage;
          return;
        }

        const mainTrack = mainSlider.querySelector('.splide__track');
        const mainHeight = Math.round(mainTrack?.getBoundingClientRect().height || 0);
        const sliderWidth = Math.round(thumbnailSlider.getBoundingClientRect().width || 0);

        if (!mainHeight || !sliderWidth) return;

        // Keep thumbnail width unchanged and compute how many square thumbnails fit in the main image height.
        const thumbnailSize = sliderWidth;
        const calculatedPerPage = Math.max(1, Math.floor((mainHeight + desktopGap) / (thumbnailSize + desktopGap)));

        if (lastMode === 'desktop' && lastHeight === mainHeight && lastPerPage === calculatedPerPage) {
          return;
        }

        thumbnails.options = {
          direction: 'ttb',
          height: `${mainHeight}px`,
          perPage: calculatedPerPage,
          gap: desktopGap,
          focus: 'start',
          trimSpace: false,
          drag: thumbnailCount > calculatedPerPage,
          wheel: thumbnailCount > calculatedPerPage,
          releaseWheel: true,
        };
        thumbnails.refresh();

        lastMode = 'desktop';
        lastHeight = mainHeight;
        lastPerPage = calculatedPerPage;
      };

      const scheduleThumbnailLayout = () => {
        if (thumbnailLayoutFrame !== null) {
          cancelAnimationFrame(thumbnailLayoutFrame);
        }
        thumbnailLayoutFrame = requestAnimationFrame(() => {
          thumbnailLayoutFrame = null;
          applyThumbnailLayout();
        });
      };

      main.on('mounted moved resized', scheduleThumbnailLayout);
      thumbnails.on('mounted moved resized', scheduleThumbnailLayout);

      thumbnailResizeListener = () => scheduleThumbnailLayout();
      window.addEventListener('resize', thumbnailResizeListener, { passive: true });

      const mainTrack = mainSlider.querySelector('.splide__track');
      if (window.ResizeObserver && mainTrack) {
        thumbnailResizeObserver = new ResizeObserver(() => scheduleThumbnailLayout());
        thumbnailResizeObserver.observe(mainTrack);
      }

      scheduleThumbnailLayout();
    }

    // Mount sliders
    main.mount();
    if (thumbnails) {
      thumbnails.mount();
    }

    // Video control functionality
    let currentActiveVideo = null;

    function handleVideoControl() {
      const activeSlide = mainSlider.querySelector('.splide__slide.is-active');
      const activeVideo = activeSlide ? activeSlide.querySelector('video') : null;

      // Pause previous active video
      if (currentActiveVideo && currentActiveVideo !== activeVideo) {
        currentActiveVideo.pause();
      }

      // Play new active video if exists
      if (activeVideo) {
        activeVideo.play().catch((error) => {
          console.log('Video autoplay failed:', error);
        });
      }

      // Update current active video reference
      currentActiveVideo = activeVideo;
    }

    // Handle video control on slide change
    main.on('moved', handleVideoControl);
    main.on('mounted', handleVideoControl);

    // Store instances for cleanup
    if (!window.splideInstances) {
      window.splideInstances = new Map();
    }
    window.splideInstances.set('main-slider', main);
    if (thumbnails) {
      window.splideInstances.set('thumbnail-slider', thumbnails);
    }

    window.productGalleryCleanup = () => {
      if (thumbnailResizeListener) {
        window.removeEventListener('resize', thumbnailResizeListener);
      }

      if (thumbnailResizeObserver) {
        thumbnailResizeObserver.disconnect();
      }
    };
  }

  // Make function globally available
  window.initializeProductGallery = initializeProductGallery;
  } catch(e) { console.error(e); }
})();

})();
